export default "__VITE_ASSET__00dea294__"